<template>
<div class="pageMobileReset">
  <XR-head titleText="修改手机号" :rightShow="false" ></XR-head>
  <mu-stepper :activeStep="activeStep" class="mobileResetSetup">
    <mu-step>
      <mu-step-label>
        验证
      </mu-step-label>
    </mu-step>
    <mu-step>
      <mu-step-label>
        绑定
      </mu-step-label>
    </mu-step>
    <mu-step>
      <mu-step-label>
        成功
      </mu-step-label>
    </mu-step>
  </mu-stepper>  
  <div class="mobileResetSetupContent">
    <p v-if="finished" class="finishedContent">
      恭喜您，已修改手机号!<a href="javascript:;" @click="reset">点这里</a>可以继续修改
    </p>
    <template v-if="!finished">
      <p class="title">{{content}}</p>
      <mu-divider></mu-divider>
      <div class="mobileResetForm">
        <mu-row gutter>
          <mu-col width="100" tablet="100" desktop="33">
            <mu-text-field label="旧手机号" type="number" icon=":fa fa-phone"  onkeypress='return( /[\d]/.test(String.fromCharCode(event.keyCode) ) )'  labelFloat :maxLength="11" v-if="activeStep==0?true:false" :disabled="activeStep==0?true:false" fullWidth v-model="oldPhoneInfo.mobile" />
            <mu-text-field label="新手机号" type="number" icon=":fa fa-phone"  onkeypress='return( /[\d]/.test(String.fromCharCode(event.keyCode) ) )'  labelFloat :maxLength="11" v-if="activeStep==1?true:false" fullWidth v-model="newPhoneInfo.mobile" />
          </mu-col>
        </mu-row>
        <mu-row gutter>
          <mu-col width="70" tablet="75" desktop="33">
            <mu-text-field label="短信验证码" helpText="点击右侧按钮获取" icon=":fa fa-envelope-o" v-if="activeStep==0?true:false" labelFloat fullWidth v-model="oldPhoneInfo.code" />
            <mu-text-field label="短信验证码" helpText="点击右侧按钮获取" icon=":fa fa-envelope-o" v-if="activeStep==1?true:false" labelFloat fullWidth v-model="newPhoneInfo.code" />
          </mu-col>
          <mu-col width="30" tablet="25" desktop="33">      
            <mu-raised-button :label="smsBtnText" class="sms-button" @click="getSmsCode()" secondary/>   
          </mu-col>
        </mu-row>
      </div>
      <div class="resetButton">
        <mu-raised-button class="UpButton" label="上一步" :disabled="activeStep === 0" @click="handlePrev"/>
        <mu-raised-button class="LowButton" :label="activeStep === 2 ? '完成' : '下一步'" primary @click="handleNext"/>
      </div>
    </template>
  </div>
  <XR-toast ref="XRtoast"></XR-toast>
</div>
</template>


<script>
export default {
  data () {
    return {
      activeStep: 0,
      isSms:false,
      oldPhoneInfo:{
        mobile:'',
        code: '',
        isTestPhone:false
      },
      isNewSms:false,
      newPhoneInfo:{
        mobile: '',
        code: ''
      },
      smsBtnText:'获取短信',
      oldInterval:0,
      newInterVal:0
    }
  },
  computed: {
    content () {
      let message = ''
      switch (this.activeStep) {
        case 0:
          message = '请验证您的旧手机'
          break
        case 1:
          message = '请绑定您的新手机'
          break
        default:
          message = '请重新开始'
          break
      }
      return message
    },
    finished () {
      return this.activeStep > 1
    }
  },
  mounted(){
    this.getMemberInfo()
  },
  methods: {
    getMemberInfo(){           
      var ths = this;   
      ths.$post(
        "/Shop/UserServer/GetUserInfo"
      ).then(function(res) {
        if(!res.IsSuccess){
          ths.$refs.XRtoast.failed(res.Msg, true)
        }else{    
          ths.loaded =false          
          ths.$refs.XRtoast.hide()
          ths.oldPhoneInfo.mobile=res.Data.mobile
          ths.oldPhoneInfo.isTestPhone = res.Data.IsTestPhone
        }
      });      
    },
    handleNext () {         
      switch (this.activeStep) {
        case 0:
          this.validateCode()
          break
        case 1:
          this.bindNewMobile()
          break
        default:
          break
      }
    },
    handlePrev () {
      this.activeStep--
    },
    reset () {
      this.activeStep = 0
      this.oldPhoneInfo.code=''
      this.newPhoneInfo.mobile=''
      this.newPhoneInfo.code=''
      clearInterval(this.oldInterval)
      clearInterval(this.newInterVal)
      this.smsBtnText = '获取短信'
    },
    getSmsCode: function(){      
      switch (this.activeStep) {
        case 0:
          this.sendSmsCode()
          break
        case 1:
          this.sendNewSmsCode()
          break
        default:
          break
      }
    },
    sendSmsCode:function(){
      var ths = this;   
      if(!ths.isSms){        
        ths.$post(
          "/Shop/UserServer/ModifyMobileSendSms"
        ).then(function(res) {
          ths.$refs.XRtoast.hide()
          if(!res.IsSuccess){
            ths.$refs.XRtoast.failed(res.Msg, true)
          }else{         
            ths.isSms=true 
            ths.smsBtnText = res.Data * 60;
            ths.oldInterval = setInterval(function(){
              if(ths.smsBtnText >0){
                ths.smsBtnText--
                ths.isSms=true 
              }else{
                ths.isSms=false 
                ths.smsBtnText = '获取短信'
                clearInterval(ths.oldInterval)
              }
            }, 1000)  
          }
        });
      }
    },
    validateCode: function(){
      var ths = this;   
      ths.$post(
        "/Shop/UserServer/ModifyMobileValidateCode",
        JSON.stringify(this.oldPhoneInfo)
      ).then(function(res) {
        ths.$refs.XRtoast.hide()
        if(!res.IsSuccess){
          ths.$refs.XRtoast.failed(res.Msg, true)
        }else{          
          ths.activeStep++
          ths.smsBtnText = '获取短信'
        }
      });
    },
    sendNewSmsCode:function(){
      if(!this.newPhoneInfo.mobile){
        this.$refs.XRtoast.failed('请输入新手机号', true)
        return
      }
      
      var ths = this;   
      if(!ths.isNewSms){
         ths.$post(
          "/Shop/UserServer/ModifyMobileSendNewMobileSms",
          JSON.stringify(this.newPhoneInfo)
        ).then(function(res) {
          ths.$refs.XRtoast.hide()
          if(!res.IsSuccess){
            ths.$refs.XRtoast.failed(res.Msg, true)
          }else{      
            ths.isNewSms= true    
            ths.smsBtnText = res.Data * 60;
            ths.newInterVal = setInterval(function(){
              if(ths.smsBtnText >0){
                ths.smsBtnText--
                ths.isNewSms= true    
              }else{
                ths.isNewSms= false    
                ths.smsBtnText = '获取短信'
                clearInterval(ths.newInterVal)
              }
            }, 1000)  
          }
        });
      }
    },    
    bindNewMobile: function(){
      if(!this.newPhoneInfo.mobile){
        this.$refs.XRtoast.failed('请输入新手机号', true)
        return
      }
      if(!this.newPhoneInfo.code){
        this.$refs.XRtoast.failed('请输入验证码', true)
        return
      }
      var ths = this;   
      ths.$post(
        "/Shop/UserServer/ModifyMobileBindNewMobile",
        JSON.stringify(this.newPhoneInfo)
      ).then(function(res) {
        ths.$refs.XRtoast.hide()
        if(!res.IsSuccess){
          ths.$refs.XRtoast.failed(res.Msg, true)
        }else{    
          ths.activeStep++
             
          ths.$refs.XRtoast.success(res.Msg, true)
          ths.getMemberInfo()
        }
      });
    },
  }
}
</script>

<style>
#app .pageMobileReset {
  width: 100%;
  margin: auto;
}

.pageMobileReset .mobileResetSetup{
  width: 100%;
  padding: 0 10%;
  background: white;
}

.pageMobileReset .mobileResetSetupContent{
  margin-top: 10px;
  background: white;
  width: 100%;
}
.pageMobileReset .mobileResetSetupContent p.title{
  text-align: center;
  padding: 30px 0;
}
.pageMobileReset .mobileResetForm{
  margin-top: 10px;
  padding: 10px 0 40px;
  background: white;
  width: 100%;
}
.pageMobileReset .sms-button{
  margin-top: 28px;
  margin-bottom: 12px;
}


.pageMobileReset .resetButton {
  text-align: center;
  padding: 30px 0;
  background: #F0F2F5;
}

.pageMobileReset .UpButton {
  margin-top: 12px;
  margin-right: 12px;
}
.pageMobileReset .LowButton {
  margin-top: 12px;
  margin-right: 12px;
}

.pageMobileReset .finishedContent{
  padding: 40px 0;
  text-align: center;
}
.pageMobileReset .mu-text-field-line.disabled {
  border-bottom: 1px solid #edeff2;
}
</style>




// WEBPACK FOOTER //
// src/pages/usercenter/mobileChangeReset.vue